import React from "react";
import Icon from "../icon";
import Avatar from "../avatar";
import {contextLine, highlightParts, searchTypeMeta} from "./search-config";
import {dateToPersian} from "../../utils";

// One result: coloured kind icon, the title with the searched words highlighted, and the context line under it.
// Used by the header dropdown and by the /search page (`detailed` adds the person and the date).
export function HighlightedText({text, ranges}) {
    return highlightParts(text, ranges).map((part, index) => (
        part.match
            ? <mark key={index} className="global-search-mark">{part.text}</mark>
            : <React.Fragment key={index}>{part.text}</React.Fragment>
    ));
}

function SearchResultItem({item, translate, active = false, detailed = false, onSelect, onHover, id}) {
    const meta = searchTypeMeta(item.type);
    const context = contextLine(item, translate);
    return (
        <a
            id={id}
            role="option"
            aria-selected={active}
            href={`#${item.type}-${item.documentId || item.id}`}
            className={`global-search-item ${active ? "is-active" : ""}`}
            onMouseEnter={onHover}
            onMouseDown={(event) => event.preventDefault()}
            onClick={(event) => {
                event.preventDefault();
                onSelect?.(item);
            }}
        >
            <span className={`global-search-icon tone-${meta.tone}`}>
                <Icon icon={`mi mi:${meta.icon}`}/>
            </span>
            <span className="global-search-item-text">
                <span className="global-search-item-title">
                    <HighlightedText text={item.title || translate("search.untitled")} ranges={item.ranges}/>
                </span>
                {context && <span className="global-search-item-context">{context}</span>}
            </span>
            {detailed && (
                <span className="global-search-item-side">
                    {item.person?.member && <Avatar size="normal" memberData={item.person.member} tooltip/>}
                    {item.updatedAt && <span className="text-xs text-500 white-space-nowrap">{dateToPersian(item.updatedAt)}</span>}
                </span>
            )}
        </a>
    );
}

export default SearchResultItem;
